////////////////////////////////////////////
// WALLET BALANCE — NATIVE-TOKEN BALANCE OF THE CONNECTED ACCOUNT
////////////////////////////////////////////
//
// TWO READ PATHS, ONE SHAPE: RH READS THE PUBLIC EVM RPC CLIENT-SIDE
// (wagmi useBalance — SAME KEYLESS CLIENT THE SWAP BOX USES); SOLANA GOES
// THROUGH GET /api/wallet/:owner/balance SO THE KEYED SOLANA RPC STAYS
// SERVER-SIDE, LIKE EVERY OTHER SOLANA READ. 30s POLL, LAST VALUE KEPT ON
// A FAILED REFRESH; null UNTIL THE FIRST READ LANDS.
import { useQuery } from "@tanstack/react-query";
import { useBalance } from "wagmi";
import { getJson } from "@/lib/api/client";
import { fmtEth, fmtSol } from "@/lib/format";
import { useNetwork } from "@/config/useNetwork";

export function useWalletBalance(address: string | null): string | null {

  const net = useNetwork();
  const isRh = net.isRh;

  const evm = useBalance({
    address: isRh && address ? (address as `0x${string}`) : undefined,
    chainId: net.rh.chainId,
    query: { enabled: isRh && !!address, refetchInterval: 30_000, retry: false },
  });

  const sol = useQuery({
    queryKey: ["wallet-balance", net.net, address],
    queryFn: () => getJson<{ lamports: string }>(
      "/api/wallet/" + address + "/balance?net=" + net.net),
    enabled: !isRh && !!address,
    refetchInterval: 30_000,
    placeholderData: (prev) => prev,
    retry: false,
  });

  if (isRh)
    return evm.data ? fmtEth(evm.data.value) + " ETH" : null;
  return sol.data ? fmtSol(BigInt(sol.data.lamports)) + " SOL" : null;
}
